'use client';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${props => props.theme.palette.gray.light};
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 10px;
  padding: 30px 20px;
`;

export const Timeline = styled.div`
  background: ${props => props.theme.palette.background.default};
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  gap: 17px;
  overflow: hidden;
  padding: 20px 20px 15px;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex-grow: 1;
  gap: 10px;
  flex: 1 0 0;
`;

export const Badges = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-bottom: 20px;
  }
`;
